import { routes } from '../../router'
import { GPOItem } from '../../features/MyCommunity/Gpo/types'

export const ADD_GPO_DETAILS_BREADCRUMBS = (name?: string) => {
  return [
    {
      children: 'My Community',
      href: routes.myCommunity
    },
    {
      children: 'GPO',
      href: `${routes.myCommunity}${routes.gpo}`
    },
    {
      children: name ? name : 'Create GPO'
    }
  ]
}

export const initialState: GPOItem = {
  address: null,
  name: '',
  website: '',
  phone_number: null,
  uuid: ''
}
